import { RESURFACED_EXCLUDED } from '../../../core/constants';
import BookstatListTab from './BookstatListTab';
import { excludedRowActions } from './digestRowActions';

const renderActions = excludedRowActions(RESURFACED_EXCLUDED);

const ResurfacedKindleExcluded = () => <BookstatListTab id={RESURFACED_EXCLUDED} renderActions={renderActions} />;

export default ResurfacedKindleExcluded;
